/* eslint-disable react-hooks/exhaustive-deps */
'use client';
import { useEffect } from 'react';

import { updateQueryStringParameters } from '@/lib/utils';

import { useAppRouter } from '@/components/hooks/useAppRouter';
import useClientTranslation from '@/components/hooks/useClientTranslation';
import useIsMobile from '@/components/hooks/useScreenSize';

const DetectMb = ({
  slug,
  partnerProvider,
}: {
  slug: string;
  partnerProvider?: string;
}) => {
  const isMobile = useIsMobile();
  const { currentLink } = useClientTranslation('');
  const { router } = useAppRouter();
  useEffect(() => {
    if (isMobile) {
      const link = updateQueryStringParameters(currentLink('/') as string, {
        partnerProvider: partnerProvider || '',
        slug: slug || '',
      });
      if (link !== window.location.href) router.push(link);
    } else {
      if (slug) {
        //  TODO: auto redirect pc
        // if (window.location.pathname !== currentLink(`/game/${slug}`)) {
        //   router.push(`/game/${slug}`);
        // }
      }
    }
  }, [isMobile, slug]);
  return null;
};

export default DetectMb;
